import { AlertCircle } from "lucide-react"
import { cn } from "@/lib/utils"
import "./inprogress-icon.css"

export default function InProgressIcon({
  size,
  className
}: {
  size?: number
  className?: string
}) {
  return (
    <div className="fade-animation">
      <AlertCircle size={size} className={cn("text-red-500", className)} />
    </div>
  )
}